<template>
    <!-- 普通签到 -->
    <div class="flex-column padding-20-30" v-if="checkin.template == 0">
        <div class="top-10">
          <span class="title">{{checkin.title}}</span>
        </div>
        <div class="top-10 flex-row max">
          <span class="text-28-99">活动发起人：<span :style="{color:checkin.name_color?checkin.name_color:'#262626'}">{{checkin.signature}}</span></span>
          <img @click="toCert" class="img_no_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220413/cc64dc95ff41c1f65590e20a8534191f.png" v-if="checkin.owner_cert_type==-1 && (checkin.is_owner == 1 )" />
          <img class="img_no_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220413/b34dd9668a7b76530bfcec776d60b31a.png" v-if="checkin.owner_cert_type == -1 && checkin.is_owner == 0" />
          <img class="img_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220126/b124c6878aa8908be741e3971dacece6.png" v-if="checkin.owner_cert_type==1" />
          <img class="img_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220126/9043bea476e19b0e61f18a4e7398f341.png" v-if="checkin.owner_cert_type==0" />
        </div>
        <div class="top-10">
            <span class="text-28-99">签到日期：{{ startDate }} 至 {{ endDate }}</span>
        </div> 
        <div v-if="checkin.checkinday[0] != 8 && checkin.checkinday[0] != 9" class="flex-column top-10">
            <span class="text-28-99"> 
                {{ checkin.checkinTip == "每日" ? "" : checkin.checkinTip }}
                <span v-if="showTimeLine">
                    可签到时间：
                    <span v-for="(item, index) in timeList" :key="index">{{ item[0] }}至{{ item[1] }} </span>
                </span>
            </span>
        </div>
        <div class="top-10">
          <span class="text-28-99">第{{checkin.days_current}}/{{checkin.days_length}}天 共{{checkin.join_num}}人参与</span>
        </div>

        <div class="flex-row top-10" v-if="checkin.exchange_item.score > 0">
            <span class="text-28-99">签到积分：每次签到{{ checkin.exchange_item.score }}</span>
        </div>

        <div class="flex-column" v-if="!hideInfo && checkin.rules.length > 0 && !(checkin.rules.length == 1 && !checkin.rules[0].value)">
            <div class="flex-row top-10">
                <span class="text-28-99">活动说明：</span>
                <span @click="toggleExpanded()" v-if="!expanded" class="text-28-99" style="color: #12b7f5">点击展开↓</span>
            </div>
            <activity-content :content="checkin.rules" v-if="expanded"></activity-content>
            <div v-if="expanded" class="flex-row top-10">
                <span @click="toggleExpanded()"  class="text-28-99" style="color: #12b7f5">点击收起↑</span>
            </div>
        </div>
        <div class="flex-row top-10" v-else-if="!hideInfo">
            <span class="text-28-99">活动说明：无</span>
        </div>
    </div>
    <!-- 会议签到 -->
    <div class="flex-column padding-20-30" v-else-if="checkin.template == 1">
        <div class="top-10">
            <span class="text-28-99">会议名称：{{checkin.title}}</span>
        </div>
        <div class="top-10">
            <span class="text-28-99">签到日期：{{ startDate }} 至 {{ endDate }}</span>
        </div>
        <div class="top-10">
            <span class="text-28-99">主办单位：{{checkin.signature}}</span>
        </div>
        <div class="top-10">
            <span class="text-28-99">签到时间：</span>
            <span class="text-28-99" v-for="(item, index) in timeList" :key="index">{{ item[0] }}至{{ item[1] }} </span>
        </div>
        <div  class="top-10" v-if="checkin.rule.length > 0">
            <span class="text-28-99">签到规则：{{checkin.rule}}</span>
        </div>
        <div  class="top-10" v-else>
            <span class="text-28-99">签到规则：无</span>
        </div>
    </div>
    <!-- 班级签到 -->
    <div class="flex-column padding-20-30" v-else-if="checkin.template == 2">
        <div class="top-10">
            <span class="text-28-99">班级名称：{{checkin.title}}</span>
        </div>
        <div class="top-10">
            <span class="text-28-99">班级管理：{{checkin.signature}}</span>
        </div>
        <div class="top-10">
            <span class="text-28-99">班级日期：{{ startDate }} 至 {{ endDate }}</span>
        </div>
        <div class="top-10">
            <span class="text-28-99">班级介绍：{{checkin.rule?checkin.rule:'无'}}</span>
        </div>
        <div class="top-10" v-if="checkin.joined_tip">
            <span class="text-28-99">参与须知{{checkin.joined_tip}}</span>
        </div>
    </div>
</template>
<script>
import {
  getTimeString,
  formatDate
} from "@/utils/common.js";
import ActivityContent from '@/components/ActivityContent.vue'
export default {
   name: '',
   props:{
       checkin:{
           type: Object,
           default: null
       },
       hideInfo:{
            type: Boolean,
            default: false,
       }
   },
   data:()=>{
       return {
           expanded: false
       }
   },
   components:{
       'activity-content': ActivityContent
   },
   computed:{
       showTimeLine() {
           if(this.checkin.time_list) {
               if( getTimeString(this.checkin.time_list[0][0]) == "00:00" && getTimeString(this.checkin.time_list[0][1]) == "23:59") {
                   return false;
               }else {
                   return true
               }
           }
           return false
       },
       timeList() {
           if(this.checkin.time_list) {
               let timeList = this.checkin.time_list.map(item=>{
                   item[0] = getTimeString(item[0])
                   item[1] = getTimeString(item[1])
                   return item
               })
               return timeList
           }
           return []
       },
       startDate() {
           if (this.checkin.start_date) {
               return formatDate( new Date(this.checkin.start_date * 1000),"yyyy-MM-dd")
           }
           return ''
       },
       endDate() {
           if(this.checkin.end_date) {
               return formatDate(new Date(this.checkin.end_date * 1000), "yyyy-MM-dd");
           }
           return ""
       }
   },
   methods: {
      toggleExpanded () {
           this.expanded = !this.expanded;
      },
      toCert() {
        this.$router.replace({ name: 'certStatus', query: { showqr: '1' } })
      }
      
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}
.icon-30-28 {
  width: rem(30);
  height: rem(28);
  margin-right: rem(10);
}
.text-30-black {
  font-size: rem(30);
  color: #333;
}
.top-10 {
  margin-top: rem(10);
}
.text-28-99 {
  font-size: rem(28);
  color: #262626;
}
.title {
  font-size: rem(44);
  color: #262626;
  font-weight: bold;
}
.img_no_cer {
  width: rem(114);
  height: rem(34);
  margin-left: rem(10);
}
.img_cer {
  width: rem(124);
  height: rem(34);
  margin-left: rem(10);
}
.max {
  max-width: rem(680);
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/ActivityBox.vue